import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@/nova/components';

import { HeaderPill, StatsGlyph } from './StatsPill.styles';

export interface StatsPillProps {
  /** Open the asset's stats sheet. */
  onClick: () => void;
}

/** The "Stats" pill of a marketing composer's header, next to its version picker: opens the asset's stats sheet. */
export const StatsPill = ({ onClick }: StatsPillProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <HeaderPill type="button" aria-label={t('Stats')} onClick={onClick}>
      <StatsGlyph aria-hidden="true" />
      <Text tag="span" text="Stats" />
    </HeaderPill>
  );
};

export default StatsPill;
